module.exports = __webpack_public_path__ + "stylesheets/both-landings-common_3624fe476a6db466c2a5038c84af359f.css";


//////////////////
// WEBPACK FOOTER
// ./app/assets/stylesheets/landing/both-landings-common.less
// module id = vzSK
// module chunks = 153